module.exports = __webpack_public_path__ + "static/media/YM60_5.34d27f0c.jpg";